import { defineStore } from 'pinia';

export const useUpdateStore = defineStore('update', {
  state: () => ({
    version: null,
    mismatch: false,
    refresh_version: null,
    refresh_version_mismatch: false,
    alert: null,
    alertVisible: false,
    show_woocommerce_update_modal: false,
  }),

  actions: {
    setVersion(value) {
      this.version = value;
    },

    setMismatch(value) {
      this.mismatch = value;
    },

    setRefreshVersion(value) {
      this.refresh_version = value;
    },

    setRefreshVersionMismatch(value) {
      this.refresh_version_mismatch = value;
    },

    setAlert(value) {
      this.alert = value;
    },

    setAlertVisible(value) {
      this.alertVisible = value;
    },

    setShowWoocommerceUpdateModal(value) {
      this.show_woocommerce_update_modal = value;
    },
  },
});
